import { useState, useEffect } from 'react';
import { useCurrentUserHook } from "../Authentication/useUserHook";
import { useHistory } from "react-router-dom";

const useMenuItemProps = ({openUiSettingsForm}={}) => {
  const history = useHistory();
  const {currentUser} = useCurrentUserHook();

  let menuItemProps = currentUser?.id ? {
    'dashboard':{
      'icon':'fas fa-home',
      'sid':'dashboard',
      'link':'/ecn/table'
    },
    'contact_requests':{
      'icon':'fas fa-solid fa-book',
      'sid':'contact_requests',
      'link':'/list/contacts'
    },
    'org_facilities':{
      'icon':'fas fa-hospital',
      'sid':'org_facilities',
      'link':`/ecn/list/facilities/${currentUser.current_organization_id}/${currentUser?.current_subscription?.id}`
    },
    'org_onboardings':{
      'icon':'fas fa-hospital',
      'sid':'contact_requests',
      'link':`/org/onboarding/${currentUser.current_organization_id}`
    },
    'orgs':{
      'icon':'fas fa-hospital',
      'sid':'orgs',
      'link':'/list/organizations'
    },
    'org_backups':{
      'icon':'fas fa-database',
      'sid':'contact_requests',
      'link':`/backup/${currentUser.current_organization_id}`
    },
    'subscriptions':{
      'icon':'fas fa-user-shield',
      'sid':'subscriptions',
      'link':`/list/subscriptions`
    },
    'members':{
      'icon':'fas fa-users',
      'sid':'members',
      'link':`/${currentUser.current_organization.data.name}/members/${currentUser.current_organization_id}`
    },
    'org_members_view':{
      'icon':'fas fa-users',
      'sid':'org_member_view',
      'link':`/${currentUser.current_organization.data.name}/view/members/${currentUser.current_organization_id}`
    },
    'roles':{
      'icon':'fas fa-user',
      'sid':'roles',
      'link':`/ecn/role/journey/${currentUser.id}/${currentUser.current_organization_id}/${currentUser?.current_subscription?.id}`
    },
    'digital_content':{
      'icon':'fas fa-newspaper',
      'sid':'digital_content',
      'link':`/digital_contents`
    },
    'marketing_content':{
      'icon':'fas fa-newspaper',
      'sid':'digital_content',
      'link':`/marketing_contents/${currentUser.current_organization_id}`
    },
    'membership_content':{
      'icon':'fas fa-newspaper',
      'sid':'membership_content',
      'link':`/membership_contents/${currentUser.current_organization_id}`
    },
    'help':{
      'icon':'far fa-question-circle',
      'sid':'help',
      'link':`/help`
    },
    'support_req':{
      'icon':'far fa-question-circle',
      'sid':'feedback',
      'link':`/list/feedback`
    },
    'events':{
      'icon':'fas fa-calendar',
      'sid':'events',
      'link':'/list/events'
    },
    'data_sources':{
      'icon':'fas fa-database',
      'sid':'data_sources',
      'link':'/list/forms'
    },
    'user_reg':{
      'icon':'fas fa-user',
      'sid':'user_reg',
      'link':`/list/user/registration/${currentUser.current_organization_id}`
    },
    'org_ui_setting':{
      'icon':'fas fa-user',
      'sid':'org_ui_setting',
      'link':`/org/theme`
    },
    'portal_settings':{
      'icon':'fas fa-user',
      'sid':'portal_settings',
      'onSelect':openUiSettingsForm
    },
    'prompts':{
      'icon':'fas fa-user',
      'sid':'prompts',
      'link':'/ai/prompts'
    },
    'feedbacks':{
      'icon':'far fa-question-circle',
      'sid':'feedbacks',
      'link':'/list/feedback'
    },
    'org_alumni':{
      'icon': 'fas fa-user-graduate',
      'sid':'org_alumni',
      'link':`/list/alumni`
    },
    'org_faculty':{
      'icon': 'fas fa-chalkboard-teacher',
      'sid':'org_faculty',
      'link':`/list/faculties`
    },
    'org_non_faculty':{
      'icon': 'fas fa-chalkboard-teacher',
      'sid':'org_non_faculty',
      'link':`/list/non/faculties`
    },
     'help':{
      'icon': 'fas fa-question-circle',
      'sid':'help',
      'link':`/help`
    },
    'course_completions':{
      'icon': 'fas fa-graduation-cap',
      'sid':'course_completions',
      'link':`/list/course_completions`
    },
    'product_features': {
      'icon': 'fas fa-box-open',
      'sid': 'product_features',
      'link': `/list/product_features`
    },
    'org_portal': {
      'icon':'fas fa-hospital',
      'sid':'org_portal',
      'link':`/member/portal/${currentUser.current_organization_id}`
    },
    'suppliers': {
      'icon':'fas fa-user-graduate',
      'sid':'suppliers',
      'link':`/list/suppliers`
    },
    'cf_proposals': {
      'icon':'fas fa-box-open',
      'sid':'cf_proposals',
      'link':`/list/call_for_proposals`
    },
    'global_partners': {
      'icon': 'fas fa-box-open',
      'sid': 'global_partners',
      'link': `/list/global_partners`
    }
  } : {};

  const sideMenuRoute = () => {
    const sid = currentUser.current_member?.home_page?.sid || (currentUser.current_organization?.org_obd_id ? 'org_portal' : null);
    const route = menuItemProps[sid];
    history.push(route?.link || "/ecn/table");
  }

  return {
    sideMenuRoute,
    menuItemProps
  }

}

export {useMenuItemProps};